import React from "react";
//Material imports
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import { createTheme } from "@limitless/portal";
import InfoDialog from "../../components/header/app-info-header-item/InfoDialog";
// Modern Imports
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";
// Icon Imports
import CloudIcon from "@limitless/icons/Cloud";
const AppInfo = () => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const originalTheme = createTheme();
  const handleButtonClick = () => {
    setOpenDialog(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(CloudIcon, null),
    label: "",
    onClick: handleButtonClick
  }), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: originalTheme
  }, /*#__PURE__*/React.createElement(InfoDialog, {
    open: openDialog,
    setOpen: setOpenDialog
  })));
};
AppInfo.propTypes = {};
export default AppInfo;